define('i18n/en-us',['require','ns'],function (require) {
	'use strict';

	var ns = require('ns');

	ns.resources = ns.resources || {};

	ns.resources['en-us'] = {
		resendVerificationEmailSuccess: 'Success',
        fieldIsRequired: 'The field is required',
        passwordMismatch: 'Passwords do not match',
        passwordInvalid: 'Password must contain at least 8 alpha-numeric characters',
        live: 'Live',
        livePending: 'Upcoming',
        skymateBadge: 'Subscribers',
        skyplusBadge: 'On-Demand',
        freeForMemberBadge: 'Member'
	};
});
